<template>
  <div>
    <header>
      <el-tabs v-model="activeTable" class="table-box" @tab-click="handleClick">
        <el-tab-pane label="链接修改日志" name="url"></el-tab-pane>
        <el-tab-pane label="QQ修改日志" name="qq"></el-tab-pane>
      </el-tabs>
    </header>
    <div v-loading="loading">
      <div v-if="activeTable === 'url'">
        <el-table :data="dataList">
          <el-table-column
            prop="before_url"
            label="变更前URL"
          ></el-table-column>
          <el-table-column prop="after_url" label="变更后URL"></el-table-column>
          <el-table-column prop="after_url" label="类型">
            <template slot-scope="{ row }">
              <span v-if="row.type === 1">用户修改</span>
              <span v-else>后台修改</span>
            </template>
          </el-table-column>
          <el-table-column prop="updated_at" label="变更时间"></el-table-column>
        </el-table>
      </div>
      <div v-if="activeTable === 'qq'">
        <el-table v-loading="loading" :data="dataList">
          <el-table-column prop="before_qq" label="变更前QQ"></el-table-column>
          <el-table-column prop="after_qq" label="变更后QQ"></el-table-column>
          <el-table-column prop="updated_at" label="变更时间"></el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getData } from '../../http'

export default {
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      query: {
        page: 1
      },
      activeTable: 'url',
      dataList: undefined,
      loading: false,
      dataMeta: undefined,
    }
  },
  watch: {
    activeTable(val) {
      this.dataMeta = undefined
      this.query.page = 1
    }
  },
  methods: {
    handleClick(tab, event) {
      //切换tab
      if (tab.name === "url") {
        this.getUrlTableData()
      }
      if (tab.name === "qq") {
        this.getQQTableData()
      }
    },
    getUrlTableData() {
      //获取链接修改记录
      this.loading = true
      let params = this.query
      getData(`url_record/${this.id}`, params)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    getQQTableData() {
      //获取qq变更记录
      this.loading = true
      let params = this.query
      getData(`qq_record/${this.id}`, params)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      this.query.page = page
      if (this.activeTable === 'url') {
        this.getUrlTableData()
      } else if (this.activeTable === 'qq') {
        this.getQQTableData()
      }
    },
  },
  created() {
    this.getUrlTableData()
  }
}
</script>

<style>
</style>
